import { SET_FILTER_DATA } from '../actionTypes';
import { templatesActions } from '../reducer';

export default (values) => templatesActions[SET_FILTER_DATA](values);
